import "./edit-transaction.scss";

import { VoidTransactionFormSchema } from "@factory/form/form.rule";
import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderButton from "@shared/ui/header-button/header-button";
import HeaderContent from "@shared/ui/header-content/header-content";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import { Button } from "primereact/button";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormTransaction from "../form-transaction/form-transaction";
import { useEditTransaction } from "./edit-transaction.hook";

export function EditTransaction() {
  const {
    isLoading,
    transactionError,
    formMethod,
    voidFormMethod,
    showVoidDialog,
    actions,
    setShowVoidDialog,
    handleVoidTransaction,
    handleBack,
    handleAction,
  } = useEditTransaction();

  const { control: voidFormControl } = voidFormMethod;
  const { getValues } = formMethod;
  const voidedBy = getValues("voidedBy");

  const title = <h1>Edit Transaction</h1>;
  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const voided = (
    <div className="card">
      <div className="bg-red-500 p-4 text-white font-semibold mb-4">
        Voided By: {getValues("voidedFirstName")} {getValues("voidedLastName")}
      </div>
    </div>
  );
  const mainContent = (
    <div>
      {voidedBy && voided}
      <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
        <FormTransaction />
      </section>
    </div>
  );

  const voidDialog = (
    <Dialog
      header="Void Transaction"
      visible={showVoidDialog}
      style={{ width: "20vw" }}
      onHide={() => {
        if (!showVoidDialog) return;
        setShowVoidDialog(false);
      }}
    >
      <div className="pb-5">
        <InputControl
          control={voidFormControl}
          name="voidedBy"
          label="Enter Manager Username"
          className="w-full"
        />
        <InputControl
          control={voidFormControl}
          name="authentication"
          label="Enter Manager Password"
          type="password"
          className="w-full"
        />
      </div>
      <div className="flex space-x-4 justify-end">
        <Button
          label="Cancel"
          outlined
          onClick={() => setShowVoidDialog(false)}
        />
        <Button
          severity="danger"
          label="Confirm"
          onClick={handleVoidTransaction}
        />
      </div>
    </Dialog>
  );

  return (
    <div id="EditTransaction" className="transaction">
      <HeaderContent
        title={title}
        backIcon={<FaChevronLeft />}
        onBack={() => handleBack()}
      >
        <HeaderButton actions={actions} onAction={handleAction} />
      </HeaderContent>

      <section className="p-7">
        {voidDialog}
        <ConfirmDialog />
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          {transactionError && !isLoading && displayError}
          {!isLoading ? mainContent : null}
        </FormProvider>
      </section>
    </div>
  );
}

export default EditTransaction;
